export default __webpack_public_path__ + "static/media/text-input-success.041ca894.svg";